import {
    token,
    postRequest
} from "../../utils/api";
export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {},
    getters: {}
}